import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home.vue'
import NoContent from '@/components/NoContent.vue'

Vue.use(Router)

export default new Router({
    routes: [
        {
            path: '/',
            name: 'Home',
            component: Home,
            order: 3
        },
        {
            path: '/what',
            name: 'What we do',
            component: NoContent,
            order: 1
        },
        {
            path: '/work',
            name: 'Work',
            component: NoContent,
            order: 2
        },
        {
            path: '/who',
            name: 'Team',
            component: NoContent,
            order: 4
        },
        {
            path: '/how',
            name: 'How we work',
            component: NoContent,
            order: 5
        }
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js